import every from 'lodash/every';
import find from 'lodash/find';
import { EDomain } from '../base/types';
import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IExercisesState;
  // other features we don't care of
  [otherKeys: string]: any;
}

export const getFeatureState = (state: IAppState) => state[Reducer.statePropName];

const getUserState = (state: IAppState, userId: number) => (getFeatureState(state).users ?? {})?.[userId] ?? {};

export const getDomainExercises = (state: IAppState, domain: EDomain, userId?: number) => {
  if (!userId) {
    return getFeatureState(state)[domain];
  }
  return getUserState(state, userId)[domain] ?? [];
};

export const getExerciseFromDomainByWorkoutId = (
  state: IAppState,
  domain: EDomain,
  workoutId: number,
  userId?: number
) => {
  const exercises = getDomainExercises(state, domain, userId);
  return find(exercises, ['workoutId', workoutId]);
};

export const isDomainLoaded = (state: IAppState, domain: EDomain, userId?: number) => {
  const exercises = getDomainExercises(state, domain, userId);
  return every(exercises, (exercise) => exercise.comparison !== null);
};
